import React, { useEffect, useMemo, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { CustomReactSelect, CustomAccordion, CustomButton, CustomSwitch } from '../../shared';
import { CrossCircleIcon } from '../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedCampaignPartners, getSelectedCampaignChannels } from '../../../redux/thunks/campaignThunks';
import { deleteChannel, deletePartner, deletePartnersChannel, getAllPartners, getChannelTypeTemplate, getChannelTypes, getPartnerApi, getPartnersChannels, saveChannels, savePartnerApi, savePartnerChannels, savePartners } from '../../../redux/thunks/adminSettingsThunk';
import { actions } from '../../../redux/reducers/adminSettingsReducer';
import uuid from 'react-uuid';
import * as yup from 'yup';
import { useForm, useController } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getCompanyConfigurationByTag, postCompanyConfigurationAuto } from '../../../redux/thunks/companyThunks';


const createNewPartner = yup.object({
    machineName: yup.string().required('Machine name is required!'),
    partnerName: yup.string().required('Partner name required!')
}).required();

const createNewChannel = yup.object({
    name: yup.string().required('The name field is required.'),
    channelTemplateOption: yup.string().required('The template id field is required.')
});

function VendorSetup() {
    const dispatch = useDispatch();
    const { vendorSetup,companyConfig } = useSelector(state => state.adminSettings);
    const { value } = companyConfig;
    const [apiKeyErrors, setApiKeyErrors] = useState({});
    const [isUnified, setIsUnified] = useState(false);
    
    const { partners, channels } = useSelector((state) => state.campaign);
    const {
        channleTypeTemplates, channleTypes, partnerChannels, 
        selectedPartnerData, newAPIKey, partnerApi , newPartnerChannel, isPartnerChannelDeleted, isPartnerChannelAdded, isPartnerDeleted,
        isChannelDeleted, isPartnerApiAdded
    } = vendorSetup;
    const { company } = useSelector(state => state.company);
    const {
        register: registerCreateNewPartner, handleSubmit: handleSubmitCreateNewPartner,formState: { errors: errorsCreateNewPartner } 
    } = useForm({
        resolver: yupResolver(createNewPartner), initialValues: {
            partnerName: '',
            machineName: ''
        } 
    });

    const {
        register: registerCreateNewChannel, handleSubmit: handleSubmitCreateNewChannel,formState: { errors: errorsCreateNewChannel }, control 
    } = useForm({
        resolver: yupResolver(createNewChannel), initialValues: {
            name: '',
            channelTemplateOption: ''
        } 
    });

    const {
        field: {
            value: channelTemplateOption, onChange: onChannelTemplateOptionChange, ...restChannelTemplateOptionProps 
        } 
    } = useController({ name: 'channelTemplateOption', control });
    useMemo(()=>{
        setIsUnified(value?.toLowerCase() === 'true');
    },[companyConfig,company.id]);
    useEffect(()=>{
        if(company.id){
            dispatch(getPartnersChannels({ companyId: company.id }));
            dispatch(getSelectedCampaignPartners({ companyId: company.id }));
        }
    },[isPartnerChannelDeleted,isPartnerChannelAdded]);

    useEffect(()=>{
        if(company.id){
            dispatch(getSelectedCampaignPartners({ companyId: company.id }));
        }
    },[isPartnerDeleted]);

    useEffect(()=>{
        if(company.id){
            dispatch(getSelectedCampaignChannels({ companyId: company.id }));
        }
    },[isChannelDeleted]);
    useEffect(()=>{
        if(company.id){
            dispatch(getPartnerApi({ companyId: company.id }));
        }
    },[isPartnerApiAdded]);

    useEffect(()=>{
        if(company.id){
            dispatch(getSelectedCampaignPartners({ companyId: company.id }));
            dispatch(getPartnersChannels({ companyId: company.id }));
            dispatch(getSelectedCampaignChannels({ companyId: company.id }));
            dispatch(getChannelTypes({ companyId: company.id }));
            dispatch(getChannelTypeTemplate({ companyId: company.id }));
            dispatch(getAllPartners({ companyId: company.id }));
            dispatch(getPartnerApi({ companyId: company.id }));
            dispatch(getCompanyConfigurationByTag({ companyId: company.id })).then((response) => {

                if(response.payload?.status_code !== 200){
                    dispatch(postCompanyConfigurationAuto({
                        companyId: company.id, data: { 
                            'tag': 'useUnified',
                            'value': 'false'
                        } 
                    })).then((response) => {
                        dispatch(getCompanyConfigurationByTag({ companyId: company.id }));
                    });
                }
            });
        }
    },[company.id]);

    useEffect(() => {
        if(channels){
            dispatch(actions.createSelectedPartnerData({ selectedPartners: partners, partnerChannels: partnerChannels }));
        }
    },[channels,isPartnerChannelDeleted,partners,partnerChannels]);

    const deletechannels = (channel) =>{
        dispatch(deleteChannel({ companyId: company.id, id: channel.id }));
    };

    const deletePartnerchannels = (partnerId,channel) =>{
        dispatch(deletePartnersChannel({
            companyId: company.id, partnerId: partnerId, id: channel.id 
        }));
    };

    const handleSelectedTemplate = (selectedOption) => {
        onChannelTemplateOptionChange(selectedOption ? selectedOption.id : selectedOption);
    };

    const saveNewChannel = (data) => {
        dispatch(saveChannels({
            companyId: company.id, data: {
                name: data.name,
                template_id: data.channelTemplateOption
            } 
        }));
    };

    const handleChannelForPartnerChange = (option, partnerId) => {
        dispatch(actions.createPartnerChannel({
            partnerId: partnerId,
            channelId: option.value ,
            channelName: option.label 
        }));
    };

    const saveNewPartner = (data) => {
        dispatch(savePartners({
            companyId: company.id, data: {
                machine_name: data.machineName,
                name: data.partnerName
            } 
        }));
    };

    const handleRemovePartner = (partnerId) => {
        dispatch(deletePartner({ companyId: company.id, partnerId: partnerId }));
    };

    const generatePartnerApiKey = (partnerId) => {
        const uuidKey = uuid();
        const key = 'PF' + company.id + Date.now() + '-' + uuidKey;
        dispatch(actions.createAPiKey({ payload: { partnerId: partnerId, apiKey: key } }));
    };

    const getPartnerApis = (partnerId) => {
        if(newAPIKey.length !==0 || partnerApi.length !==0){
            let apiObj = newAPIKey?.find(
                (partner) => partner.partnerId === partnerId
            );
            if (!apiObj) {
                apiObj = partnerApi?.find(
                    (partner) => partner.partnerId === partnerId
                );
            }
            if (apiObj) {
                return apiObj.apiKey;
            }
            return '';
        }
    };  

    const getAvailableChannelsForPartner = (partner) => {
        if(partner){
            return channleTypes
                ?.filter(
                    (channel) =>
                        !partner?.find(
                            (type) => type.id === channel.id
                        )
                )
                ?.map((channel) => ({ value: channel.id, label: channel.label }));
        }
    };

    const savePartnerApiKey = (partnerId) => {
        const api_key = getPartnerApis(partnerId);
        if (api_key !== '' && api_key !== null && api_key !== undefined) {
            dispatch(savePartnerApi({
                companyId: company.id,
                partnerId: partnerId,
                data: { api_key: api_key }
            }));
            setApiKeyErrors({ ...apiKeyErrors, [partnerId]: '' });
        } else{
            setApiKeyErrors({ ...apiKeyErrors, [partnerId]: 'Please enter an API key.' });
        }
  
    };

    const saveChannelForPartner = (partnerId,selectedPartner) => {
        const partnerChannel = newPartnerChannel.find(
            (pc) => pc.partnerId === selectedPartner.id
        );
        if (partnerChannel) {
            const partner = selectedPartnerData?.find(
                (p) => p.id === selectedPartner.id
            );
            if (
                partner?.campaign_type?.some(
                    (channel) => channel.id === partnerChannel.channelId
                ) === false
            ) {
                dispatch(savePartnerChannels({
                    companyId: company.id,
                    partnerId: partnerId,
                    data: { campaign_type_id: partnerChannel.channelId }
                }));
            }
        }
    };

    const handleCompanyConfig = () => {
        setIsUnified(!isUnified);
        dispatch(postCompanyConfigurationAuto({
            companyId: company.id, data: { 
                'tag': 'useUnified',
                'value': `${!isUnified}`
            } 
        })).then((response) => {
            dispatch(getCompanyConfigurationByTag({ companyId: company.id }));
        });
    };

    const renderChannels = () => channels?.map(channel => (<Box className="br-16px bg-primary-50 padding-10px">
        <Box className="flex-row-center gap-8">
            <Typography className="text-sm-medium gray-900">
                {channel.name}
            </Typography>
            <Box className='icon' onClick={() => deletechannels(channel)}>
                <img alt={channel} src={CrossCircleIcon} />
            </Box>
        </Box>
    </Box>));

    const renderSelectedPartnersChannels = (partnerId,channel) => channel?.map(channel => (<Box className="br-16px bg-primary-50 padding-10px">
        <Box className="flex-row-center gap-8">
            <Typography className="text-sm-medium gray-900">
                {channel.name}
            </Typography>
            <Box className='icon' onClick={() => deletePartnerchannels(partnerId,channel)}>
                <img alt={channel} src={CrossCircleIcon} />
            </Box>
        </Box>
    </Box>));

    const renderPartner = (partnerId,channels,partner) => (
        <Box>
            <Box className="flex-row-wrap gap-8 pb-20px">{renderSelectedPartnersChannels(partnerId,channels)}</Box>
            <Box className="flex-row-start-center gap-16 pb-20px">
                <Box>
                    <Typography className="text-md-medium gray-700">
              Add channel for partner:
                    </Typography>
                </Box>
                <Box width={200}>
                    <CustomReactSelect
                        handleFilter={(e) => handleChannelForPartnerChange(e,partnerId)}
                        options={getAvailableChannelsForPartner(partner.campaign_type)}
                        placeholder="Select Partner"
                    />
                </Box>
                <Box>
                    <CustomButton
                        buttonColor="#AD509E"
                        customStyle={{ borderRadius: '8px' }}
                        handleClick={() => saveChannelForPartner(partnerId,partner)}
                        title="Add Channel"
                        titleColor="#FFFFFF"
                    />
                </Box>
            </Box>
            <Box className="flex-row-start-center gap-16 pb-20px">
                <Box>
                    <Typography className="text-md-medium gray-700">
              Enter API key for partner:
                    </Typography>
                </Box>
                <Box className="bg-gray-50">
                    <input disabled className='custom-text-field text-md-regular bg-gray-50' placeholder='API key' type="text"  
                        value={getPartnerApis(partnerId)}
                        onChange={(e) => setApiKeyErrors({ ...apiKeyErrors, [partnerId]: null })}
                    />
                    {apiKeyErrors[partnerId] && (<span className="text-xs-regular error-500">
                        {apiKeyErrors[partnerId]}
                    </span>)}
                </Box>
                <Box>
                    <CustomButton
                        buttonColor="#AD509E"
                        customStyle={{ borderRadius: '8px' }}
                        handleClick={() => generatePartnerApiKey(partnerId)}
                        title="Generate API Key"
                        titleColor="#FFFFFF"
                    />
                </Box>
                <Box>
                    <CustomButton
                        buttonColor="#AD509E"
                        customStyle={{ borderRadius: '8px' }}
                        handleClick={()=>savePartnerApiKey(partnerId)}
                        title="Save API Key"
                        titleColor="#FFFFFF"
                    />
                </Box>
            </Box>
        </Box>
    );

    return (
        <Grid container spacing={'24px'}>
            <Grid item xs={12}>
                <Box className="box-sizing-border-box border-1-gray br-16px overflow-hidden">
                    <Box className="border-bottom-gray bg-primary-50 padding-10px">
                        <Typography className="text-lg-semi-bold primary-color">
                            Company Configuration
                        </Typography>
                    </Box>
                    <Box className="padding-24px">
                        <CustomSwitch checked={isUnified} label={'Is Unified'} onChange={()=>handleCompanyConfig()}/>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box className="box-sizing-border-box border-1-gray br-16px overflow-hidden">
                    <Box className="border-bottom-gray bg-primary-50 padding-10px">
                        <Typography className="text-lg-semi-bold primary-color">
                            Selected Channels
                        </Typography>
                    </Box>
                    <Box className="padding-24px">
                        <Box className="flex-row-wrap gap-8 pb-20px">{renderChannels()}</Box>
                        <form onSubmit={handleSubmitCreateNewChannel(saveNewChannel)}>
                            <Box className="flex-row-start-center gap-16">
                                <Box>
                                    <Typography className="text-md-medium gray-700">
                  Create new channel:
                                    </Typography>
                                </Box>
                                <Box>
                                    <input className='custom-text-field text-md-regular' placeholder='Enter Channel Name' type="text" {... registerCreateNewChannel('name')} />
                                    <span className="text-xs-regular error-500">
                                        {errorsCreateNewChannel.name?.message}
                                    </span>
                                </Box>
                                <Box>
                                    <CustomReactSelect
                                        handleFilter={(e) => handleSelectedTemplate(e)}
                                        options={ channleTypeTemplates }
                                        placeholder="Select Channel Template"
                                        selectedOption={
                                            channelTemplateOption
                                                ? channleTypeTemplates.find(
                                                    (x) => x.id === channelTemplateOption
                                                )
                                                : channelTemplateOption
                                        }
                                        useMenuPortalTarget={true}
                                        { ...restChannelTemplateOptionProps}
                                    />
                                    <span className="text-xs-regular error-500">
                                        {errorsCreateNewChannel.channelTemplateOption?.message}
                                    </span>
                                </Box>
                                <Box>
                                    <CustomButton
                                        buttonColor="#AD509E"
                                        customStyle={{ borderRadius: '8px' }}
                                        title="Save Channel"
                                        titleColor="#FFFFFF"
                                        type="submit"
                                    />
                                </Box>
                            </Box>
                        </form>
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="box-sizing-border-box border-1-gray br-16px overflow-hidden">
                    <Box className="border-bottom-gray bg-primary-50 padding-10px">
                        <Typography className="text-lg-semi-bold primary-color">
              Selected Partners
                        </Typography>
                    </Box>
                    <Box className="padding-24px">
                        <Grid container spacing={'24px'}>
                            {
                                selectedPartnerData?.map(partner => (
                                    <Grid item xs={12}>
                                        <CustomAccordion
                                            accordionContainerBackground="bg-gray-50"
                                            acoordianDetailsBackground='bg-gray-50'
                                            acoordianDetailsPadding="padding-24px"
                                            component={renderPartner(partner.id,partner.campaign_type,partner)}
                                            handleClick={() => handleRemovePartner(partner.id)}
                                            isIconEnable={true}
                                            title={partner.name}
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                        <form onSubmit={handleSubmitCreateNewPartner(saveNewPartner)}>
                            <Box className="flex-row-start-center gap-16 pt-20px">
              
                                <Box>
                                    <Typography className="text-md-medium gray-700">
                  Create new partner:
                                    </Typography>
                                </Box>
                                <Box>
                                    <input className='custom-text-field text-md-regular' placeholder='Enter Partner Name' type="text" {... registerCreateNewPartner('partnerName')} />
                                    <span className="text-xs-regular error-500">
                                        {errorsCreateNewPartner.partnerName?.message}
                                    </span>
                                </Box>
                                <Box>
                                    <input className='custom-text-field text-md-regular' placeholder='Enter Machine Name' type="text" {... registerCreateNewPartner('machineName')} />
                                    <span className="text-xs-regular error-500">
                                        {errorsCreateNewPartner.machineName?.message}
                                    </span>
                                </Box>
                                <Box>
                                    <CustomButton
                                        buttonColor="#AD509E"
                                        customStyle={{ borderRadius: '8px' }}
                                        title="Save Partner"
                                        titleColor="#FFFFFF"
                                        type="submit"
                                    />
                                </Box>
                            </Box>
                        </form>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}

export default VendorSetup;